import { c as _c } from "react/compiler-runtime";
import { Badge } from "@/components/ui/badge";
import { Battery, BatteryCharging, BatteryFull, BatteryLow, BatteryWarning } from "lucide-react";
import type { ReactNode } from "react";
export enum TenderStatus {
  ONGOING = "EN PLAZO",
  ANNOUNCED = "Anuncio Previo",
  ENDED = "Adjudicada",
  CANCELLED = "Anulada",
  PENDING = "PENDIENTE DE ADJUDICACIÓN",
  SOLVED = "Resuelta",
  OTHER = "",
}
interface StatusBadgeProps {
  readonly status: string;
}
export function StatusBadge(t0) {
  const $ = _c(15);
  const {
    status
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      icon: <BatteryFull className="size-4" />,
      className: "bg-green-100 text-green-700 dark:bg-green-500/15 dark:text-green-400"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      icon: <BatteryCharging className="size-4" />,
      className: "bg-yellow-100 text-yellow-700 dark:bg-yellow-500/15 dark:text-yellow-400"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      icon: <Battery className="size-4" />,
      className: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      icon: <BatteryWarning className="size-4" />,
      className: "bg-red-100 text-red-800 dark:bg-red-800/15 dark:text-red-200"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      icon: <BatteryLow className="size-4" />,
      className: "bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-400"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      icon: <Battery className="size-4" />,
      className: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400"
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      [TenderStatus.ONGOING]: t1,
      [TenderStatus.ANNOUNCED]: t2,
      [TenderStatus.ENDED]: t3,
      [TenderStatus.CANCELLED]: t4,
      [TenderStatus.PENDING]: t5,
      [TenderStatus.SOLVED]: t6,
      [TenderStatus.OTHER]: {
        icon: <BatteryWarning className="size-4" />,
        className: "bg-gray-100 text-gray-700 dark:bg-gray-500/15 dark:text-gray-400"
      }
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const STATUS_CONFIG = t7;
  const config = STATUS_CONFIG[Object.values(TenderStatus).includes(status as TenderStatus) ? status as TenderStatus : TenderStatus.OTHER];
  const t8 = config.className;
  const t9 = config.icon;
  let t10;
  if ($[7] !== status) {
    t10 = status.toLocaleUpperCase("es-ES");
    $[7] = status;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== config.icon || $[10] !== t10) {
    t11 = <div className="flex items-center gap-2">{t9}{t10}</div>;
    $[9] = config.icon;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== config.className || $[13] !== t11) {
    t12 = <Badge className={t8} variant="secondary">{t11}</Badge>;
    $[12] = config.className;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  return t12;
}